import React, { Component } from 'react'
import { MenuItem, Menu, Badge, IconButton, Popper, Grow, Paper, MenuList } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { NavLink as RouterLink } from "react-router-dom";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { connect } from "react-redux";
import { saveAs } from "file-saver";

class MenuNotifications extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            hasNotifications: false,
            notifications: []
        }
        this.secondsToWait = 15
        this.intervalCheckNotifications = null
        this.intervalExportVouchers = null
        this.intervalExportOffices = null
        this.intervalExportUsers = null
        this.intervalExportRates = null
        this.intervalExportDiscounts = null
        this.intervalExportHistoryCoupons = null
        this.intervalExportBillings = null
        this.intervalExportFacturacion = null
        this.intervalExportCobranzasConciliacion = null
        this.intervalExportRates = null
        this.intervalExportPromotions = null
        this.intervalExportRefunds = null
        this.headersSetCookie = window.localStorage.getItem('headersSetCookie')
    }

    componentDidMount() {
        this.intervalCheckNotifications = window.setInterval(this.checkNotifications, this.secondsToWait * 1000);

        // Verifica si tiene que consultar estado de reporte de voucher
        if (window.localStorage.getItem('hashExportVouchers')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportVouchers'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportVouchers = window.setInterval(this.checkReportExportVouchers, 10000, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de Offices
        if (window.localStorage.getItem('hashExportOffices')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportOffices'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportOffices = window.setInterval(this.checkReportExportOffices, 10000, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de Users
        if (window.localStorage.getItem('hashExportUsers')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportUsers'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportUsers = window.setInterval(this.checkReportExportUsers, 10000, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de Rates
        if (window.localStorage.getItem('hashExportRates')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportRates'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportRates = window.setInterval(this.checkReportExportRates, 10000, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de discounts
        if (window.localStorage.getItem('hashExportDiscounts')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportDiscounts'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {
                this.intervalExportDiscounts = window.setInterval(this.checkReportExportDiscounts, 10000, hashObj.hash);
            }
        }

        if (window.localStorage.getItem('hashExportHistoryCoupons')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportHistoryCoupons'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportHistoryCoupons = window.setInterval(this.checkReportExportHistoryCoupons, 10000, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de  Billings
        if (window.localStorage.getItem('hashExportBillings')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportBillings'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportBillings = window.setInterval(this.checkReportExportBillings, 500, hashObj.hash);
            }
        }

        // Verifica si tiene que consultar estado de reporte de  Facturacion
        if (window.localStorage.getItem('hashExportFacturacion')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportFacturacion'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {

                this.intervalExportFacturacion = window.setInterval(this.checkReportExportFacturacion, 500, hashObj.hash);
            }
        }

        if (window.localStorage.getItem('hashExportCobranzasConciliacion')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportCobranzasConciliacion'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {
                this.intervalExportCobranzasConciliacion = window.setInterval(this.checkReportExportCobranzasConciliacion, 500, hashObj.hash);
            }
        }

        if (window.localStorage.getItem('hashExportRate')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportRate'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {
                this.intervalExportRates = window.setInterval(this.checkReportExportRate, 500, hashObj.hash);
            }
        }

        if (window.localStorage.getItem('hashExportPromotions')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportPromotions'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {
                this.intervalExportPromotions = window.setInterval(this.checkReportExportPromotions, 500, hashObj.hash);
            }
        }

        if (window.localStorage.getItem('hashExportRefunds')) {
            let hashObj = JSON.parse(window.localStorage.getItem('hashExportRefunds'))
            if ((hashObj.status == "Pending") || (hashObj.status == undefined && hashObj.hash !== undefined)) {
                this.intervalExportRefunds = window.setInterval(this.checkReportExportRefunds, 500, hashObj.hash);
            }
        }
    }

    /**
 * Recibe los cambios de valores del store correspondiente al export voucher.
  */
    componentDidUpdate(prevProps, prevState, snapshot) {

        //export voucher
        if (prevProps.vouchersReducer.responseCheckReportVouchers !== this.props.vouchersReducer.responseCheckReportVouchers) {
            // si no hubo error en respuesta.
            if (!this.props.vouchersReducer.errorCheckReportVouchers) {
                //verifica el estado.
                if (this.props.vouchersReducer.responseCheckReportVouchers.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportVouchers)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportVouchers')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportVouchers'))
                        hashObj.status = this.props.vouchersReducer.responseCheckReportVouchers.status
                        hashObj.url = this.props.vouchersReducer.responseCheckReportVouchers.message
                        window.localStorage.setItem('hashExportVouchers', JSON.stringify(hashObj));
                    }

                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Offices
        if (prevProps.officesReducer.responseCheckReportOffices !== this.props.officesReducer.responseCheckReportOffices) {
            // si no hubo error en respuesta.
            if (!this.props.officesReducer.errorCheckReportOffices) {
                //verifica el estado.
                if (this.props.officesReducer.responseCheckReportOffices.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportOffices)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportOffices')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportOffices'))
                        hashObj.status = this.props.officesReducer.responseCheckReportOffices.status
                        hashObj.url = this.props.officesReducer.responseCheckReportOffices.message
                        window.localStorage.setItem('hashExportOffices', JSON.stringify(hashObj));
                    }

                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Users
        if (prevProps.usersReducer.responseCheckReportUsers !== this.props.usersReducer.responseCheckReportUsers) {
            // si no hubo error en respuesta.
            if (!this.props.usersReducer.errorCheckReportUsers) {
                //verifica el estado.
                if (this.props.usersReducer.responseCheckReportUsers.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportUsers)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportUsers')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportUsers'))
                        hashObj.status = this.props.usersReducer.responseCheckReportUsers.status
                        hashObj.url = this.props.usersReducer.responseCheckReportUsers.message
                        window.localStorage.setItem('hashExportUsers', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Rates
        if (prevProps.ratesReducer.responseCheckReportRates !== this.props.ratesReducer.responseCheckReportRates) {
            // si no hubo error en respuesta.
            if (!this.props.ratesReducer.errorCheckReportRates) {
                //verifica el estado.
                if (this.props.ratesReducer.responseCheckReportRates.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportRates)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportRates')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportRates'))
                        hashObj.status = this.props.ratesReducer.responseCheckReportRates.status
                        hashObj.url = this.props.ratesReducer.responseCheckReportRates.message
                        window.localStorage.setItem('hashExportRates', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Discounts
        if (prevProps.discountsReducer.responseCheckReportDiscounts !== this.props.discountsReducer.responseCheckReportDiscounts) {
            // si no hubo error en respuesta.
            if (!this.props.discountsReducer.errorCheckReportDiscounts) {
                //verifica el estado.
                if (this.props.discountsReducer.responseCheckReportDiscounts.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportDiscounts);
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportDiscounts')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportDiscounts'))
                        hashObj.status = this.props.discountsReducer.responseCheckReportDiscounts.status
                        hashObj.url = this.props.discountsReducer.responseCheckReportDiscounts.message
                        window.localStorage.setItem('hashExportDiscounts', JSON.stringify(hashObj));
                    }

                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        if (prevProps.discountsReducer.responseCheckReportHistoryCoupons !== this.props.discountsReducer.responseCheckReportHistoryCoupons) {
            // si no hubo error en respuesta.
            if (!this.props.discountsReducer.errorCheckReportHistoryCoupons) {
                //verifica el estado.
                if (this.props.discountsReducer.responseCheckReportHistoryCoupons.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportHistoryCoupons)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportHistoryCoupons')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportHistoryCoupons'))
                        hashObj.status = this.props.discountsReducer.responseCheckReportHistoryCoupons.status
                        hashObj.url = this.props.discountsReducer.responseCheckReportHistoryCoupons.message
                        window.localStorage.setItem('hashExportHistoryCoupons', JSON.stringify(hashObj));
                    }

                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Billings
        if (prevProps.billingsReducer.responseCheckReportBilling !== this.props.billingsReducer.responseCheckReportBilling) {
            // si no hubo error en respuesta.
            if (!this.props.billingsReducer.errorCheckReportOffices) {
                //verifica el estado.
                if (this.props.billingsReducer.responseCheckReportBilling.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportBillings)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportBillings')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportBillings'))
                        hashObj.status = this.props.billingsReducer.responseCheckReportBilling.status
                        hashObj.url = this.props.billingsReducer.responseCheckReportBilling.message
                        window.localStorage.setItem('hashExportBillings', JSON.stringify(hashObj));
                    }

                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Facturacion
        if (prevProps.facturacionReducer.responseCheckReportFacturacion !== this.props.facturacionReducer.responseCheckReportFacturacion) {
            // si no hubo error en respuesta.
            if (!this.props.facturacionReducer.errorCheckReporFacturacion) {
                //verifica el estado.
                if (this.props.facturacionReducer.responseCheckReportFacturacion.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportFacturacion)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportFacturacion')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportFacturacion'))
                        hashObj.status = this.props.facturacionReducer.responseCheckReportFacturacion.status
                        hashObj.url = this.props.facturacionReducer.responseCheckReportFacturacion.message
                        window.localStorage.setItem('hashExportFacturacion', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Cobranzas conciliacion
        if (prevProps.conciliationsReducer.responseCheckReportCobranzasConciliacion !== this.props.conciliationsReducer.responseCheckReportCobranzasConciliacion) {
            // si no hubo error en respuesta.
            if (!this.props.conciliationsReducer.errorCheckReportCobranzasConciliacion) {
                //verifica el estado.
                if (this.props.conciliationsReducer.responseCheckReportCobranzasConciliacion.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportCobranzasConciliacion)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportCobranzasConciliacion')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportCobranzasConciliacion'))
                        hashObj.status = this.props.conciliationsReducer.responseCheckReportCobranzasConciliacion.status
                        hashObj.url = this.props.conciliationsReducer.responseCheckReportCobranzasConciliacion.message
                        window.localStorage.setItem('hashExportCobranzasConciliacion', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Promotions
        if (prevProps.promotionsReducer.responseCheckReportPromotions !== this.props.promotionsReducer.responseCheckReportPromotions) {
            // si no hubo error en respuesta.
            if (!this.props.promotionsReducer.errorCheckReportPromotions) {
                //verifica el estado.
                if (this.props.promotionsReducer.responseCheckReportPromotions.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportPromotions)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportPromotions')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportPromotions'))
                        hashObj.status = this.props.promotionsReducer.responseCheckReportPromotions.status
                        hashObj.url = this.props.promotionsReducer.responseCheckReportPromotions.message
                        window.localStorage.setItem('hashExportPromotions', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        //export Tarifa
        if (prevProps.ratesReducer.responseCheckReportRate !== this.props.ratesReducer.responseCheckReportRate) {
            // si no hubo error en respuesta.
            if (!this.props.ratesReducer.errorCheckReportRate) {
                //verifica el estado.
                if (this.props.ratesReducer.responseCheckReportRate.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportRates)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportRate')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportRate'))
                        hashObj.status = this.props.ratesReducer.responseCheckReportRate.status
                        hashObj.url = this.props.ratesReducer.responseCheckReportRate.message
                        window.localStorage.setItem('hashExportRate', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }

        if (prevProps.productsReducer.responseCheckReportRefunds !== this.props.productsReducer.responseCheckReportRefunds) {
            // si no hubo error en respuesta.
            if (!this.props.productsReducer.errorCheckReportRefunds) {
                //verifica el estado.
                if (this.props.productsReducer.responseCheckReportRefunds.status !== "Pending") {
                    // detiene las peticiones
                    clearInterval(this.intervalExportRefunds)
                    // actualiza item en localStorage.
                    if (window.localStorage.getItem('hashExportRefunds')) {
                        let hashObj = JSON.parse(window.localStorage.getItem('hashExportRefunds'))
                        hashObj.status = this.props.productsReducer.responseCheckReportRefunds.status
                        hashObj.url = this.props.productsReducer.responseCheckReportRefunds.message
                        window.localStorage.setItem('hashExportRefunds', JSON.stringify(hashObj));
                    }
                }
                //Si esta pendiente todavía, no hago nada. El intervalo seguirá corriendo.
            }
        }
    }

    checkReportExportVouchers = (hash) => {
        this.props.checkExportVouchersList(this.headersSetCookie, hash)
    }
    checkReportExportOffices = (hash) => {
        this.props.checkExportOfficesList(this.headersSetCookie, hash)
    }
    checkReportExportUsers = (hash) => {
        this.props.checkExportUsersList(this.headersSetCookie, hash)
    }
    checkReportExportRates = (hash) => {
        this.props.checkExportRatesList(this.headersSetCookie, hash)
    }
    checkReportExportDiscounts = (hash) => {
        this.props.checkExportDiscountsList(this.headersSetCookie, hash)
    }
    checkReportExportBillings = (hash) => {
        this.props.checkExportBillingsList(this.headersSetCookie, hash)
    }
    checkReportExportHistoryCoupons = (hash) => {
        this.props.checkExportHistoryCouponsList(this.headersSetCookie, hash)
    }
    checkReportExportFacturacion = (hash) => {
        this.props.checkExportFacturacionList(this.headersSetCookie, hash)
    }
    checkReportExportCobranzasConciliacion = (hash) => {
        this.props.checkExportCobranzasConciliacionList(this.headersSetCookie, hash)
    }
    checkReportExportRate = (hash) => {
        this.props.checkExportRates(this.headersSetCookie, hash)
    }
    checkReportExportPromotions = (hash) => {
        this.props.checkExportPromotionsList(this.headersSetCookie, hash)
    }
    checkReportExportRefunds = (hash) => {
        this.props.checkExportReintegrosList(this.headersSetCookie, hash)
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    // Ejecutará la acción de aquella notificacion seleccionada y luego la borrará de la lista.
    handleNotification = (id) => {
        let objNotification = this.state.notifications.filter(noti => noti.id = id)[0];
        objNotification.action()

        let newNotifications = this.state.notifications.filter(noti => noti !== objNotification);
        this.setState({ notifications: newNotifications })
    }


    // Funciones que se dispararán segun la notificacion clickeada

    // accion report voucher
    actionExportVoucher = () => {
        if (window.localStorage.getItem('hashExportVouchers')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportVouchers'))
            if (hashObj.status == "OK") {
                this.props.updateExportVouchersList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_voucher.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportVouchers');                           // borro data en localStorage
        }
    }

    // accion report offices
    actionExportOffice = () => {
        if (window.localStorage.getItem('hashExportOffices')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportOffices'))
            if (hashObj.status == "OK") {
                this.props.updateExportOfficesList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_offices.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportOffices');                           // borro data en localStorage
        }
    }

    // accion report Users
    actionExportUsers = () => {
        if (window.localStorage.getItem('hashExportUsers')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportUsers'))
            if (hashObj.status == "OK") {
                this.props.updateExportUsersList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_users.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportUsers');                           // borro data en localStorage
        }
    }

    // accion report rates
    actionExportRates = () => {
        if (window.localStorage.getItem('hashExportRates')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportRates'))
            if (hashObj.status == "OK") {
                this.props.updateExportRatesList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_rates.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportRates');                           // borro data en localStorage
        }
    }

    // accion report Discounts
    actionExportDiscounts = () => {
        if (window.localStorage.getItem('hashExportDiscounts')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportDiscounts'))
            if (hashObj.status == "OK") {
                this.props.updateExportDiscountsList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_discounts.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportDiscounts');                           // borro data en localStorage
        }
    }

    actionExportHistoryCoupons = () => {
        if (window.localStorage.getItem('hashExportHistoryCoupons')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportHistoryCoupons'))
            if (hashObj.status == "OK") {
                this.props.updateExportHistoryCouponsList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_HistoryCoupons.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportHistoryCoupons');                           // borro data en localStorage
        }
    }

    // accion report billigs
    actionExportBilling = () => {
        if (window.localStorage.getItem('hashExportBillings')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportBillings'))
            if (hashObj.status == "OK") {
                this.props.updateExportOfficesList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_billings.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportBillings');                           // borro data en localStorage
        }
    }

    // accion report Facturacion
    actionExportFacturacion = () => {
        if (window.localStorage.getItem('hashExportFacturacion')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportFacturacion'))
            if (hashObj.status == "OK") {
                this.props.checkExportFacturacionList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_Facturacion.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportFacturacion');                           // borro data en localStorage
        }
    }

    // accion report Cobranzas conciliacion
    actionExportCobranzasConciliacion = () => {
        if (window.localStorage.getItem('hashExportCobranzasConciliacion')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportCobranzasConciliacion'))
            if (hashObj.status == "OK") {
                this.props.checkExportCobranzasConciliacionList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_Cobranzas_conciliacion.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportCobranzasConciliacion');                           // borro data en
        }
    }
    actionExportRate = () => {
        if (window.localStorage.getItem('hashExportRate')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportRate'))
            if (hashObj.status == "OK") {
                this.props.checkExportRates(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_Rate.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportRate');                           // borro data en localStorage
        }
    }

    // accion report Promociones
    actionExportPromotions = () => {
        if (window.localStorage.getItem('hashExportPromotions')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportPromotions'))
            if (hashObj.status == "OK") {
                this.props.checkExportPromotionsList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_Promotions.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportPromotions');                           // borro data en localStorage
        }
    }

    // accion report Promociones
    actionExportRefunds = () => {
        if (window.localStorage.getItem('hashExportRefunds')) {
            var hashObj = JSON.parse(window.localStorage.getItem('hashExportRefunds'))
            if (hashObj.status == "OK") {
                this.props.checkExportReintegrosList(this.headersSetCookie, hashObj.hash)    //actualizo estado de report
                saveAs(hashObj.url, "filter_Refunds.xlsx")                                  //guardo archivo.
            }
            window.localStorage.removeItem('hashExportRefunds');                           // borro data en localStorage
        }
    }


    checkNotifications = () => {
        // Verifica notificaciones de export report voucher
        if (window.localStorage.getItem('hashExportVouchers')) {
            var hashVouchers = JSON.parse(window.localStorage.getItem('hashExportVouchers'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_VOUCHER").length === 0) {
                if (hashVouchers.status !== 'Pending') {
                    let message = ""
                    if (hashVouchers.status == "OK") {
                        message = "Listado de vouchers disponible para descargar"
                    } else {
                        message = "Error al descargar listado de vouchers."
                    }
                    var objVouchers = {
                        "id": 1,
                        "name": "EXPORT_VOUCHER",
                        "message": message,
                        "action": this.actionExportVoucher,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objVouchers)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }

        if (window.localStorage.getItem('hashExportOffices')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportOffices'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_OFFICES").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Listado de oficinas disponible para descargar."
                    } else {
                        message = "Error al descargar listado de oficinas."
                    }
                    var objOffices = {
                        "id": 1,
                        "name": "EXPORT_OFFICES",
                        "message": message,
                        "action": this.actionExportOffice,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objOffices)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }


        if (window.localStorage.getItem('hashExportUsers')) {
            var hashUsers = JSON.parse(window.localStorage.getItem('hashExportUsers'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_USERS").length === 0) {
                if (hashUsers.status !== 'Pending') {
                    let message = ""
                    if (hashUsers.status == "OK") {
                        message = "Listado de usuarios disponible para descargar."
                    } else {
                        message = "Error al descargar listado de usuarios."
                    }
                    var objUsers = {
                        "id": 1,
                        "name": "EXPORT_USERS",
                        "message": message,
                        "action": this.actionExportUsers,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objUsers)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }

        if (window.localStorage.getItem('hashExportRates')) {
            var hashRates = JSON.parse(window.localStorage.getItem('hashExportRates'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_RATES").length === 0) {
                if (hashRates.status !== 'Pending') {
                    let message = ""
                    if (hashRates.status == "OK") {
                        message = "Listado de tarifas disponible para descargar."
                    } else {
                        message = "Error al descargar listado de tarifas."
                    }
                    var objRates = {
                        "id": 1,
                        "name": "EXPORT_RATES",
                        "message": message,
                        "action": this.actionExportRates,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objRates)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }

        if (window.localStorage.getItem('hashExportDiscounts')) {
            var hashDiscounts = JSON.parse(window.localStorage.getItem('hashExportDiscounts'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_DISCOUNTS").length === 0) {
                if (hashDiscounts.status !== 'Pending') {
                    let message = ""
                    if (hashDiscounts.status == "OK") {
                        message = "Listado de descuentos disponible para descargar."
                    } else {
                        message = "Error al descargar listado de descuentos."
                    }
                    var objDiscounts = {
                        "id": 1,
                        "name": "EXPORT_DISCOUNTS",
                        "message": message,
                        "action": this.actionExportDiscounts,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objDiscounts)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }

        if (window.localStorage.getItem('hashExportHistoryCoupons')) {
            var hashHistoryCoupons = JSON.parse(window.localStorage.getItem('hashExportHistoryCoupons'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_COUPON").length === 0) {
                if (hashHistoryCoupons.status !== 'Pending') {
                    let message = ""
                    if (hashHistoryCoupons.status == "OK") {
                        message = "Listado histórico de cupones disponible para descargar."
                    } else {
                        message = "Error al descargar listado histórico de cupones."
                    }
                    var objCoupons = {
                        "id": 1,
                        "name": "EXPORT_COUPON",
                        "message": message,
                        "action": this.actionExportHistoryCoupons,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objCoupons)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_VOUCHER.")
            }
        }

        if (window.localStorage.getItem('hashExportBillings')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportBillings'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_BILLING").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Listado de cobranzas disponible para descargar."
                    } else {
                        message = "Error al descargar listado de cobranzas."
                    }

                    var objBillings = {
                        "id": 1,
                        "name": "EXPORT_BILLING",
                        "message": message,
                        "action": this.actionExportBilling,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objBillings)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                    // window.localStorage.removeItem('hashExportBillings');
                }
            } else {
                // console.log("Ya existe la notificacion EXPORT_BILLING.")
            }
        }

        // facturacion
        if (window.localStorage.getItem('hashExportFacturacion')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportFacturacion'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_FACTURACION").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Listado de facturacion disponible para descargar."
                    } else {
                        message = "Error al descargar listado de facturacion."
                    }

                    var objFacturacion = {
                        "id": 1,
                        "name": "EXPORT_FACTURACION",
                        "message": message,
                        "action": this.actionExportFacturacion,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objFacturacion)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                    // window.localStorage.removeItem('hashExportFacturacion');
                }
            } else {
            }
        }

        // conbranzas conciliacion
        if (window.localStorage.getItem('hashExportCobranzasConciliacion')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportCobranzasConciliacion'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_COBRANZA_CONCILIACION").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Conciliación de conbranzas disponible para descargar."
                    } else {
                        message = "Error al descargar conciliación de cobranzas."
                    }

                    var objCobranzaConciliacion = {
                        "id": 1,
                        "name": "EXPORT_COBRANZA_CONCILIACION",
                        "message": message,
                        "action": this.actionExportCobranzasConciliacion,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objCobranzaConciliacion)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                    // window.localStorage.removeItem('hashExportCobranzasConciliacion');
                }
            } else {
            }
        }

        // tarifas
        if (window.localStorage.getItem('hashExportRate')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportRate'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_RATE").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Reporte de tarifa disponible para descargar."
                    } else {
                        message = "Error al descargar el reporte de tarifa."
                    }

                    var objFacturacion = {
                        "id": 1,
                        "name": "EXPORT_RATE",
                        "message": message,
                        "action": this.actionExportRate,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objFacturacion)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                    // window.localStorage.removeItem('hashExportCobranzasConciliacion');
                }
            } else {
            }
        }

        // promociones
        if (window.localStorage.getItem('hashExportPromotions')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportPromotions'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_PROMOTIONS").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Listado de promociones disponible para descargar."
                    } else {
                        message = "Error al descargar listado de promociones."
                    }

                    var objPromotions = {
                        "id": 1,
                        "name": "EXPORT_PROMOTIONS",
                        "message": message,
                        "action": this.actionExportPromotions,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objPromotions)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
            }
        }

        // reintegros
        if (window.localStorage.getItem('hashExportRefunds')) {
            var hashOffices = JSON.parse(window.localStorage.getItem('hashExportRefunds'))
            if (this.state.notifications.filter(noti => noti.name = "EXPORT_REFUNDS").length === 0) {
                if (hashOffices.status !== 'Pending') {
                    let message = ""
                    if (hashOffices.status == "OK") {
                        message = "Listado de reintegros disponible para descargar."
                    } else {
                        message = "Error al descargar listado de reintegros."
                    }

                    var objRefunds = {
                        "id": 1,
                        "name": "EXPORT_REFUNDS",
                        "message": message,
                        "action": this.actionExportRefunds,
                    }
                    var objNotifications = this.state.notifications
                    objNotifications.push(objRefunds)
                    this.setState({
                        hasNotifications: true,
                        notifications: objNotifications
                    })
                }
            } else {
            }
        }
    }


    render() {

        function handleListKeyDown(event) {
            if (event.key === 'Tab') {
                event.preventDefault();
                this.setState({ anchorEl: null });
            }
        }

        return (
            <>
                <IconButton
                    className="menuNotificationButton"
                    aria-label="nuevas notificaciones"
                    color="inherit"
                    onClick={this.handleClick}
                >
                    <Badge badgeContent={this.state.notifications.length} color="secondary" overlap="rectangular">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>

                <Popper
                    className="menuNotificationPopper"
                    open={Boolean(this.state.anchorEl)}
                    anchorEl={this.state.anchorEl}
                    role={undefined} transition disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <MenuList autoFocusItem={Boolean(this.state.anchorEl)} id="menu-list-grow" onKeyDown={handleListKeyDown}>

                                        {this.state.notifications.map((notification, index) => {
                                            return (
                                                <MenuItem key={index} onClick={() => this.handleNotification(notification.id)}>{notification.message}</MenuItem>
                                            )
                                        })
                                        }
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </>
        )
    }
}

const mapStateToProps = reducers => {
    return reducers;
};

const mapDispachToProps = dispatch => {
    return {
        updateExportVouchersList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_VOUCHERS", access, hash }),
        checkExportVouchersList: (access, hash) => dispatch({ type: "CHECK_EXPORT_VOUCHERS", access, hash }),
        updateExportOfficesList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_OFFICES", access, hash }),
        checkExportOfficesList: (access, hash) => dispatch({ type: "CHECK_EXPORT_OFFICES", access, hash }),
        updateExportUsersList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_USERS", access, hash }),
        checkExportUsersList: (access, hash) => dispatch({ type: "CHECK_EXPORT_USERS", access, hash }),
        updateExportRatesList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_RATES", access, hash }),
        checkExportRatesList: (access, hash) => dispatch({ type: "CHECK_EXPORT_RATES", access, hash }),
        updateExportDiscountsList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_DISCOUNTS", access, hash }),
        checkExportDiscountsList: (access, hash) => dispatch({ type: "CHECK_EXPORT_DISCOUNTS", access, hash }),
        updateExportHistoryCouponsList: (access, hash) => dispatch({ type: "UPDATE_EXPORT_DISCOUNTS_HISTORY", access, hash }),
        checkExportHistoryCouponsList: (access, hash) => dispatch({ type: "CHECK_EXPORT_DISCOUNTS_HISTORY", access, hash }),
        checkExportBillingsList: (access, hash) => dispatch({ type: "CHECK_EXPORT_BILLING", access, hash }),
        checkExportFacturacionList: (access, hash) => dispatch({ type: "CHECK_EXPORT_FACTURACION", access, hash }),
        checkExportCobranzasConciliacionList: (access, hash) => dispatch({ type: "CHECK_EXPORT_COBRANZA_CONCILIACION", access, hash }),
        checkExportRates: (access, hash) => dispatch({ type: "CHECK_EXPORT_RATES", access, hash }),
        checkExportPromotionsList: (access, hash) => dispatch({ type: "CHECK_EXPORT_PROMOTIONS", access, hash }),
        checkExportReintegrosList: (access, hash) => dispatch({ type: "CHECK_EXPORT_REFUNDS", access, hash })
    };
};
export default connect(mapStateToProps, mapDispachToProps)(MenuNotifications);